/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Storefront_Buy_NowInputs */

const en_storefront_buy_now = /** @type {(inputs: Storefront_Buy_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buy Now`)
};

const es_storefront_buy_now = /** @type {(inputs: Storefront_Buy_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comprar ahora`)
};

const fr_storefront_buy_now = /** @type {(inputs: Storefront_Buy_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acheter maintenant`)
};

const de_storefront_buy_now = /** @type {(inputs: Storefront_Buy_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jetzt kaufen`)
};

const ja_storefront_buy_now = /** @type {(inputs: Storefront_Buy_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`今すぐ購入`)
};

const zh_storefront_buy_now = /** @type {(inputs: Storefront_Buy_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`立即购买`)
};

const ar_storefront_buy_now = /** @type {(inputs: Storefront_Buy_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اشترِ الآن`)
};

const id_storefront_buy_now = /** @type {(inputs: Storefront_Buy_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beli Sekarang`)
};

const it_storefront_buy_now = /** @type {(inputs: Storefront_Buy_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acquista Ora`)
};

const ru_storefront_buy_now = /** @type {(inputs: Storefront_Buy_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Купить сейчас`)
};

const pt_storefront_buy_now = /** @type {(inputs: Storefront_Buy_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comprar Agora`)
};

const ko_storefront_buy_now = /** @type {(inputs: Storefront_Buy_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`지금 구매하기`)
};

/**
* | output |
* | --- |
* | "Buy Now" |
*
* @param {Storefront_Buy_NowInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const storefront_buy_now = /** @type {((inputs?: Storefront_Buy_NowInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Storefront_Buy_NowInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_storefront_buy_now(inputs)
	if (locale === "es") return es_storefront_buy_now(inputs)
	if (locale === "fr") return fr_storefront_buy_now(inputs)
	if (locale === "de") return de_storefront_buy_now(inputs)
	if (locale === "ja") return ja_storefront_buy_now(inputs)
	if (locale === "zh") return zh_storefront_buy_now(inputs)
	if (locale === "ar") return ar_storefront_buy_now(inputs)
	if (locale === "id") return id_storefront_buy_now(inputs)
	if (locale === "it") return it_storefront_buy_now(inputs)
	if (locale === "ru") return ru_storefront_buy_now(inputs)
	if (locale === "pt") return pt_storefront_buy_now(inputs)
	return ko_storefront_buy_now(inputs)
});